import React, {useRef, useLayoutEffect} from "react"
import {LoaderClass} from "./LoaderClass"
import {removeCookieOfFolderId} from "../functions"
import {useNavigate} from "react-router-dom"
import {FaFolder, FaFolderOpen} from "react-icons/fa"

export default function GoogleUploadCard({data, lang}) {

    const {
        tree,
        selectedFolder,
        uploading,
        progress,
        result,
        error,
        files,
        fileNames,
        setFileNames,
        currentIndex,
        handleToggle,
        handleFileChange,
        handleUpload,
        handleDrag,
        handleDrop,
        dragActive
    } = data

    const containerRef = useRef(null)
    const navigate = useNavigate()

    useLayoutEffect(() => {
        const id = selectedFolder?.id
        if (!id) return

        const container = containerRef.current
        const node = document.getElementById(`folder-${id}`)
        if (!container || !node) return

        const nodeTop = node.offsetTop
        const nodeBottom = nodeTop + node.offsetHeight

        const viewTop = container.scrollTop
        const viewBottom = viewTop + container.clientHeight

        if (nodeTop < viewTop) {
            container.scrollTo({top: nodeTop - 20, behavior: "smooth"})
        } else if (nodeBottom > viewBottom) {
            container.scrollTo({
                top: nodeBottom - container.clientHeight + 20,
                behavior: "smooth"
            })
        }

    }, [tree, selectedFolder.id])

    const TreeNode = ({id, level = 0}) => {
        const node = tree[id]
        if (!node) return null

        const isSelected = selectedFolder.id === node.id

        return (
            <div>
                <div
                    id={`folder-${id}`}
                    className={`folder-class ${isSelected ? 'folder-class--selected' : ''}`}
                    onClick={() => handleToggle(node)}
                    style={{ paddingLeft: level * 16 }}
                >
                    <div className="folder-class__icon">
                        {node.loading ? (
                            <LoaderClass marginTop={1} width={1} height={1}/>
                        ) : (
                            <span>
                                {node.expanded ?
                                    <FaFolderOpen size={18} color={"orange"} /> :
                                    <FaFolder size={18} color="orange" />}
                            </span>
                        )}
                    </div>
                    <span>{node.name}</span>
                </div>

                {node.expanded &&
                node.children.map(childId => (
                    <TreeNode key={childId} id={childId} level={level + 1}/>
                ))}
            </div>
        )
    }

    if (result && result.ok) {
        removeCookieOfFolderId(selectedFolder.id)
        setTimeout(() => {
            navigate(`/${lang.lang}/google-drive/open/${selectedFolder.id}`, {replace: true})
        }, 2000)
    }

    return (
        <div
            className={`upload-container ${dragActive ? 'upload-container--drag' : ''}`}
            onDragEnter={handleDrag}
            onDragOver={handleDrag}
            onDragLeave={handleDrag}
            onDrop={handleDrop}
        >
            <div
                ref={containerRef}
                className="upload-tree"
            >
                <TreeNode id={"root"}/>
            </div>

            <div className="upload-target-row">
                <p>{`${lang.body.googleDrivePage.googleUploadFile.loadHere}: `}</p>
                <h5 className="upload-target-name">
                    {tree[selectedFolder.id]?.name || selectedFolder.name}
                </h5>
            </div>

            {/* --- ДО ЗАГРУЗКИ --- */}
            {!uploading && !result && (
                <>
                    <label className="upload-btn">
                        {`${lang.body.googleDrivePage.googleUploadFile.selectFiles}`}
                        <input
                            type="file"
                            multiple
                            onChange={handleFileChange}
                            hidden
                        />
                    </label>

                    {files && files.length > 0 && (
                        <div className="upload-files-list">
                            {files.map(f => (
                                <div key={f.name} className="upload-file-row">
                                    <input
                                        className="upload-file-name-input"
                                        value={fileNames[f.name] || f.name}
                                        onChange={e =>
                                            setFileNames(prev => ({
                                                ...prev,
                                                [f.name]: e.target.value
                                            }))
                                        }
                                        autoFocus={false}
                                    />
                                </div>
                            ))}
                        </div>
                    )}
                </>
            )}

            {/* --- ВО ВРЕМЯ ЗАГРУЗКИ / ПОСЛЕ --- */}
            {files && files.length > 0 && (
                <div className="upload-files-progress-list">
                    {uploading && (
                        <div className="upload-current-file">
                            {`${lang.body.googleDrivePage.googleUploadFile.fileIsLoading} (${currentIndex + 1} ${lang.body.googleDrivePage.googleUploadFile.of} ${files.length})`}
                            <br />
                            <strong>{fileNames[files[currentIndex].name]}</strong>
                        </div>
                    )}

                </div>
            )}

            {/* --- ОБЩИЙ ПРОГРЕСС --- */}
            {(uploading || result) && (
                <div className="upload-total-progress">
                    <div className="progress-bar">
                        <div
                            className="progress-bar__fill"
                            style={{ width: `${progress}%` }}
                        />
                        <div className="progress-bar__label">
                            {progress}%
                        </div>
                    </div>
                </div>
            )}

            {!uploading && !result && (
                <button
                    onClick={handleUpload}
                    disabled={!files || !files.length}
                    className="upload-button"
                    style={{opacity: !files || !files.length ? 0 : 1}}
                >
                    {lang.body.googleDrivePage.googleUploadFile.upload}
                </button>
            )}

            {error && <div className="upload-error">{error}</div>}
            {result && result.ok && (
                <div className="upload-success">
                    {lang.body.googleDrivePage.googleUploadFile.success}
                </div>
            )}
        </div>
    )
}
